import { render, staticRenderFns } from "./lottery-home.vue?vue&type=template&id=81ec336e&scoped=true&"
import script from "./lottery-home.vue?vue&type=script&lang=js&"
export * from "./lottery-home.vue?vue&type=script&lang=js&"
import style0 from "./lottery-home.vue?vue&type=style&index=0&id=81ec336e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ec336e",
  null
  
)

export default component.exports